"use client";

import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useMemo } from "react";

import { PathType } from "app/(PROTECTED)/customer/[applicationId]/_utils";
import { ApplicationStatusNumberValue } from "constants/status";
import { cn } from "utils/cn";

export type NavItem = {
  url: string;
  name: "申込" | "審査" | "契約" | "契約中" | "解約済み";
  style: string;
  path: PathType;
  checkMarkVisibleStatusNumberArray: ApplicationStatusNumberValue[];
  ngNumber: 2 | 4 | 6 | 8 | 10 | 11;
};

const ApplicationNav = ({ id, status }: { id: string; status: ApplicationStatusNumberValue }) => {
  const navItems: NavItem[] = useMemo(
    () => [
      {
        url: `/customer/${id}/confirm/`,
        name: "申込",
        style: "application-nav-arrow-left",
        path: "confirm",
        checkMarkVisibleStatusNumberArray: [3, 4, 5, 6, 7, 8, 9, 10, 11],
        ngNumber: 2,
      },
      {
        url: `/customer/${id}/review/`,
        name: "審査",
        style: "application-nav-arrow-mid",
        path: "review",
        checkMarkVisibleStatusNumberArray: [5, 6, 7, 8, 9, 10, 11],
        ngNumber: 4,
      },
      {
        url: `/customer/${id}/contract/`,
        name: "契約",
        style: "application-nav-arrow-mid",
        path: "contract",
        checkMarkVisibleStatusNumberArray: [7, 8, 9, 10, 11],
        ngNumber: 6,
      },
      {
        url: `/customer/${id}/under-contract/`,
        name: "契約中",
        style: "application-nav-arrow-mid",
        path: "under-contract",
        checkMarkVisibleStatusNumberArray: [9, 10, 11],
        ngNumber: 8,
      },
      {
        url: `/customer/${id}/cancelled-contract/`,
        name: "解約済み",
        style: "application-nav-arrow-right",
        path: "cancelled-contract",
        checkMarkVisibleStatusNumberArray: [10, 11],
        ngNumber: 11,
      },
    ],
    [id]
  );

  const pathname = usePathname();

  const splitPathname = pathname.split("/")[3] as PathType;

  return (
    <div className="shadow-common flex w-[786px]">
      {navItems.map((item) => {
        // ngNumber - 1 = 対応している状態
        const isAllowAccess = status >= item.ngNumber - 1;

        return (
          <Link
            href={isAllowAccess ? item.url : pathname}
            replace
            key={item.name}
            className={cn("block h-full flex-1 text-gray", {
              "cursor-not-allowed text-text-disabled": !isAllowAccess,
            })}
          >
            <div
              className={`flex h-full items-center justify-center gap-2 text-center ${
                splitPathname === item.path ? "bg-link text-white hover:bg-link-dark" : "bg-white hover:bg-neutral-50"
              } ${item.style}`}
            >
              {item.checkMarkVisibleStatusNumberArray.filter((num) => num === status).length > 0 && (
                <FontAwesomeIcon icon={faCheck} size="sm" color="#EE8F00" />
              )}
              <p>{item.name}</p>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default ApplicationNav;
